import React from 'react'
import { StyledIcon } from '../StyledIcon'

const style = { fill: '#ff9800' }
const HalfStarIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 510 510"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <path
      d="M510,197.472l-183.37-15.734L255,12.75l-71.629,168.988L0,197.472l0,0l0,0l139.103,120.539L97.41,497.25L255,402.186l0,0
  l157.59,95.039l-41.692-179.239L510,197.472z M255,354.348V117.172l43.605,102.918l111.689,9.588l-84.711,73.389l25.398,109.166
  L255,354.348z"
      style={style}
    />
  </StyledIcon>
)

export default HalfStarIcon
